import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation createSubjectNote($data: createSubjectNoteInput!) {
    createSubjectNote(data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const createSubjectNoteRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.CreateSubjectNoteInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'subject_note/create_subject_note',
  async (params: {data: TYPES.CreateSubjectNoteInput;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.createSubjectNote;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const createSubjectNoteSlice = createSlice({
  name: 'create_subject_note',
  initialState: initialState,
  reducers: {
    createSubjectNoteClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(createSubjectNoteRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(createSubjectNoteRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(createSubjectNoteRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { createSubjectNoteClear } = createSubjectNoteSlice.actions;

export const createSubjectNote = createSelector(
  (state: RootState) => state.subjectNote.createSubjectNote.result,
  (state: RootState) => state.subjectNote.createSubjectNote.error,
  (state: RootState) => state.subjectNote.createSubjectNote.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default createSubjectNoteSlice.reducer;